import { useAuth0 } from '@auth0/auth0-react';
import { Outlet } from "react-router-dom";
import { NavBar } from "@playsistemico/modo-ui-portal-lib";
import IconModo from "src/global/assets/images/modo-icon.svg";
import AvatarIcon from "src/components/AvatarIcon";
import LayoutComplete from "src/components/LayoutComplete";
import ContentLayout from "src/layouts/ContentLayout";

import { styles } from "./styles";

export default function Promotions() {
  const { classes } = styles();

  const { isAuthenticated } = useAuth0();

  return (
    <div className={classes.screenContainer}>
      <NavBar
        logo={
          <img src={IconModo} alt="modo-logo" width="128" className={classes.modoIcon}/>
        }
        onCLickLogo={() => {}}
        avatar={isAuthenticated && <AvatarIcon />}
      />
      <ContentLayout fullContainer className={classes.contentLayout}>
        <LayoutComplete>
          <div className={classes.outlet}>
            <Outlet />
          </div>
        </LayoutComplete>
      </ContentLayout>
    </div>
  );
}
